import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { TENANT_PATHS } from '../../../routing/paths.ts';

/**
 * Legacy `/sox-risks/:riskId/edit` bookmarks open the details view.
 * Edit mode is toggled in-page on the view route only (not via URL).
 */
export function LegacySoxRiskEditRoute(): React.ReactElement {
  const { riskId } = useParams();
  const encoded = encodeURIComponent(String(riskId ?? '').trim());
  const viewPath = TENANT_PATHS.SOX_RISKS_VIEW.replace(':riskId', encoded || 'unknown');
  return <Navigate to={viewPath} replace />;
}
